import { fromNano } from '@ton/core'

/**
 * Formats a TON amount to a human-readable string with consistent decimal places.
 *
 * @param amount - Amount in nano-TON units (string/bigint) or TON units (number)
 * @param decimalPlaces - Number of decimal places (defaults to 1)
 * @returns Formatted TON amount as string
 *
 * @example
 * formatTon(toNano('1.23456')) // "1.2" (from nano-units)
 * formatTon('1234567890') // "1.2" (from nano-units)
 * formatTon(1.23456) // "1.2" (from TON units)
 */
export const formatTon = (
  amount?: string | bigint | number,
  decimalPlaces = 1,
): string => {
  if (!amount && amount !== 0) {
    return '0'
  }

  // If amount is a number, it's already in TON units
  if (typeof amount === 'number') {
    return amount.toFixed(decimalPlaces)
  }

  // Otherwise, convert from nano-units
  return Number(fromNano(amount)).toFixed(decimalPlaces)
}
